import dayjs from "dayjs"
var XLSX = require("xlsx")

export const downloadXLXS = (args, filename, date = "") => {
  const ws = XLSX.utils.json_to_sheet(args)
  const wb = XLSX.utils.book_new()

  const newWs = { ...ws }

  if (filename == "Balances") {
    delete newWs.A1
    delete newWs.B1
    delete newWs.C1
    delete newWs.D1
    delete newWs.E1
    delete newWs.F1
    delete newWs.G1
    delete newWs.H1
    delete newWs.I1
  }

  XLSX.utils.book_append_sheet(wb, newWs, "SheetJS")
  /* generate XLSX file and send to client */
  XLSX.writeFile(
    wb,
    `${filename}${date === "no_date" ? "" : `_${dayjs().format("DD-MM-YYYY")}`}.xlsx` ||
      `export.xlsx`,
  )
}
